// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Iisp","rootNoMargin":"styles_rootNoMargin__3RVBx"};